var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-form",
    {
      attrs: { form: _vm.form },
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.handleSubmit.apply(null, arguments)
        },
      },
    },
    [
      _c(
        "a-form-item",
        [
          _c(
            "a-radio-group",
            {
              attrs: { "button-style": "solid" },
              model: {
                value: _vm.form.type,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "type", $$v)
                },
                expression: "form.type",
              },
            },
            [
              _c("a-radio-button", { attrs: { value: "module" } }, [
                _vm._v(_vm._s(_vm.$t("modules.module"))),
              ]),
              _vm._v(" "),
              _c("a-radio-button", { attrs: { value: "relation" } }, [
                _vm._v(_vm._s(_vm.$t("modules.relation"))),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "a-row",
        { attrs: { gutter: 16 } },
        [
          _c(
            "a-col",
            { attrs: { span: 12 } },
            [
              _c(
                "a-form-item",
                { attrs: { label: _vm.$t("modules.displayName") } },
                [
                  _c("a-input", {
                    model: {
                      value: _vm.form.displayName,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "displayName", $$v)
                      },
                      expression: "form.displayName",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "a-col",
            { attrs: { span: 12 } },
            [
              _c(
                "a-form-item",
                { attrs: { label: _vm.$t("modules.icon") } },
                [
                  _c("MaterialIconPicker", {
                    model: {
                      value: _vm.form.icon,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "icon", $$v)
                      },
                      expression: "form.icon",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.form.type === "relation"
        ? [
            _c(
              "a-form-item",
              [
                _c(
                  "a-radio-group",
                  {
                    attrs: { "button-style": "solid" },
                    model: {
                      value: _vm.form.relation.type,
                      callback: function ($$v) {
                        _vm.$set(_vm.form.relation, "type", $$v)
                      },
                      expression: "form.relation.type",
                    },
                  },
                  [
                    _c(
                      "a-radio-button",
                      { attrs: { value: "table-to-table" } },
                      [_vm._v(_vm._s(_vm.$t("modules.relationPairTableTable")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "a-radio-button",
                      {
                        staticStyle: { display: "none" },
                        attrs: { value: "table-to-standart" },
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("modules.relationPairTableStandart"))
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a-radio-button",
                      { attrs: { value: "standart-to-table" } },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("modules.relationPairStandartTable"))
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _vm.form.relation.type === "table-to-table"
              ? [
                  _c(
                    "a-row",
                    { attrs: { gutter: 16 } },
                    [
                      _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "a-card",
                            { attrs: { title: _vm.$t("modules.fromColumn") } },
                            [
                              _c("TableConnectionForm", {
                                attrs: { tables: _vm.tables },
                                model: {
                                  value: _vm.form.relation.tableToTable.from,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form.relation.tableToTable,
                                      "from",
                                      $$v
                                    )
                                  },
                                  expression: "form.relation.tableToTable.from",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "a-card",
                            { attrs: { title: _vm.$t("modules.toColumn") } },
                            [
                              _c("TableConnectionForm", {
                                attrs: { tables: _vm.tables },
                                model: {
                                  value: _vm.form.relation.tableToTable.to,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form.relation.tableToTable,
                                      "to",
                                      $$v
                                    )
                                  },
                                  expression: "form.relation.tableToTable.to",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.form.relation.type === "table-to-standart"
              ? [
                  _c(
                    "a-row",
                    { attrs: { gutter: 16 } },
                    [
                      _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "a-card",
                            { attrs: { title: _vm.$t("modules.fromColumn") } },
                            [
                              _c("TableConnectionForm", {
                                attrs: { tables: _vm.tables },
                                model: {
                                  value: _vm.form.relation.tableToStandart.from,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form.relation.tableToStandart,
                                      "from",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "form.relation.tableToStandart.from",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "a-card",
                            { attrs: { title: _vm.$t("modules.toColumn") } },
                            [
                              _c("StandartModuleConnectionForm", {
                                attrs: {
                                  "contact-properties": _vm.contactProperties,
                                },
                                model: {
                                  value: _vm.form.relation.tableToStandart.to,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form.relation.tableToStandart,
                                      "to",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "form.relation.tableToStandart.to",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.form.relation.type === "standart-to-table"
              ? [
                  _c(
                    "a-row",
                    { attrs: { gutter: 16 } },
                    [
                      _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "a-card",
                            { attrs: { title: _vm.$t("modules.fromColumn") } },
                            [
                              _c("StandartModuleConnectionForm", {
                                attrs: {
                                  "contact-properties": _vm.contactProperties,
                                },
                                model: {
                                  value: _vm.form.relation.standartToTable.from,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form.relation.standartToTable,
                                      "from",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "form.relation.standartToTable.from",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "a-card",
                            { attrs: { title: _vm.$t("modules.toColumn") } },
                            [
                              _c("TableConnectionForm", {
                                attrs: { tables: _vm.tables },
                                model: {
                                  value: _vm.form.relation.standartToTable.to,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form.relation.standartToTable,
                                      "to",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "form.relation.standartToTable.to",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              : _vm._e(),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.form.type === "module"
        ? [
            _c(
              "a-form-item",
              { attrs: { label: _vm.$t("modules.table") } },
              [
                _c(
                  "a-select",
                  {
                    model: {
                      value: _vm.form.module.table,
                      callback: function ($$v) {
                        _vm.$set(_vm.form.module, "table", $$v)
                      },
                      expression: "form.module.table",
                    },
                  },
                  _vm._l(_vm.tables, function (table) {
                    return _c(
                      "a-select-option",
                      { key: table._id, attrs: { value: table._id } },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(table.name) +
                            "\n                "
                        ),
                      ]
                    )
                  }),
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "a-form-item",
              { attrs: { label: _vm.$t("modules.settings") } },
              [
                _c(
                  "a-checkbox",
                  {
                    model: {
                      value: _vm.form.module.settings.showInMainMenu,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.form.module.settings,
                          "showInMainMenu",
                          $$v
                        )
                      },
                      expression: "form.module.settings.showInMainMenu",
                    },
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("modules.showInMainMenu")) +
                        "\n            "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a-checkbox",
                  {
                    model: {
                      value: _vm.form.module.settings.apiEnabled,
                      callback: function ($$v) {
                        _vm.$set(_vm.form.module.settings, "apiEnabled", $$v)
                      },
                      expression: "form.module.settings.apiEnabled",
                    },
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("modules.apiAccess")) +
                        "\n            "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }